import { render, staticRenderFns } from "./CustomPie.vue?vue&type=template&id=36f27904"
import script from "./CustomPie.vue?vue&type=script&lang=js"
export * from "./CustomPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports